import React, { Children, useState } from "react";

export default function ReusableCard({
  children,
  title,
  func,
  buttonStatus,
  buttonname,
  text,
}) {
  return (
    <div
      className=" mt-2 card-style"
      style={{
        minWidth: "40%",
        backgroundColor: "#fff",
      }}
    >
      {title !== "" && (
        <div className="row ml-2 mr-0">
          <div className="form-group">
            <label className="form-label">{title}</label>
          </div>
        </div>
      )}

      <form id="cardForm" name="cardForm" onSubmit={func}>
        <div className="row ml-0 mr-0">
          <div className="col-8 pl-2 pr-0 ">
            <div className="form-group">{children}</div>
          </div>
          <div className="col-4 pt-3 pl-1">
            <button
              type="submit"
              className="btn btn-primary btn-block pt-1"
              disabled={buttonStatus}
            >
              {buttonname}
            </button>
          </div>
        </div>
      </form>
      {text}
    </div>
  );
}
